var OCS = OCS || {}; //TODO: Build out a means to disable the legend and re-enable it in the new panel when dragged to a new location
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_ol_map_view_class = function () {
    OCS.Viewer.Classes.OlMapView = new Class({
        Implements: [Options, Events, new Class(OCS.Viewer.Interfaces.OlObject), new Class(OCS.Viewer.Interfaces.OlEvent), new Class(OCS.Viewer.Interfaces.AbstractManager), new Class(OCS.Viewer.Interfaces.OlMapView)],
        options: {
            projection: OCS.Viewer.Config.default_projection,
            display_projection: OCS.Viewer.Config.default_display_projection,
            center_string: 'center',
            resolution_string: 'resolution',
            numZoomLevels: 18,
            defaultZoom: 6,
            minZoom: 4,
            extent: null,
            center: [-97, 35],
        },
        map_datetime_obj: null,
        link_bindings: [],
        update_panel_options_timeout: null,
        view: null,
        initialize: function (options) {
            this.setOptions(options);
            var view_ops = {
                center: ol.proj.transform(this.options.center, this.options.display_projection, this.options.projection),
                zoom: this.options.defaultZoom,
                minZoom: this.options.minZoom,
                maxZoom: this.options.numZoomLevels
            };
            if (this.options.extent) {
                view_ops.extent = this.options.extent;
            }
            this.create_view(view_ops);
            this.add_events();
        },
        destroy: function () {
            this.remove_all_events();
            this.ol_object = null;
        }
    });
};
OCS.Viewer.Functions.define_ol_map_view_class();
